import client from './api-client';

export const getConfiguracionForm = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getTareas = async(query) => {
    try {
        
        const response = await client.get(`tareas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getTareasUsuario = async(query) => {
    try {
        
        const response = await client.get(`tareas-usuario?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getConceptos = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getCasosBandeja = async(query) => {
    try {
        
        const response = await client.get(`bandeja/tareas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                casos: response.data.object,
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}


export const getXlsCasosBandeja = async(query) => {
    try {
        
        const response = await client.get(`bandeja/tareas/xls?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.file;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getRangoFechas = async(query) => {
    try {
        
        const response = await client.get(`parametros?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getIntanciaJudicial = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const servicesGetCFGRespuestaExt = async(query) => {
    try {
        
        const response = await client.get(`cfg-respuesta-ext?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const servicesGetCasosResponsableRegla = async() => {
    try {
        
        const response = await client.get(`confirmar-responsable-regla`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const servicePostConfirmaAsignacion = async(body) => {
    try {
        const response = await client.post('confirmar-responsable-regla', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}